<template>
  <section id="contact" class="lp-v2-contact">
    <div class="lp-v2-container">
      <div class="lp-v2-contact-head">
        <span class="lp-v2-contact-label">Get In Touch</span>
        <h2 class="lp-v2-contact-title">Contact Us for More Information</h2>
        <p class="lp-v2-contact-desc">
          Fill in the form below and our team will get back to you as soon as possible.
        </p>
      </div>
      <div class="lp-v2-contact-form-wrap">
        <form-field
          :is-redirect-to-wa="redirectToWa.is_redirect_to_wa"
          :wa-phone-number="redirectToWa.wa_phone_number"
          :wa-message="redirectToWa.wa_message"
          :is-landing-page-show="true"
          :hidden-submit-button="false"
          :form-id="formId"
          :user-self-data="userData"
          :landing-page-uuid="landingPageData.uuid"
          :submit-button="submitButton"
          :aggreement="aggreement"
          :input-manually="isManualInput"
          :assigned-salespersons="isManualInput ? assignedSalespersonOptions : []"
        />

        <!-- External link buttons -->
        <div
          v-if="landingPageData.url_link && landingPageData.url_link.length"
          class="lp-v2-ext-links"
        >
          <a
            v-for="(item, index) in landingPageData.url_link"
            :key="index"
            :href="item"
            target="_blank"
            class="lp-v2-ext-btn"
            :style="{ borderColor: landingPageData.color_submit_button, color: landingPageData.color_submit_button }"
          >
            {{ landingPageData.text_link[index] }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FormField from '@/views/menus/forms/form-display/FormField.vue'

export default {
  components: { FormField },
  props: {
    formId: { type: [Number, String], default: null },
    submitButton: { type: Object, default: () => ({ label: '', color: '' }) },
    aggreement: { type: String, default: '' },
    userData: { type: Object, default: null },
    landingPageData: { type: Object, required: true },
    redirectToWa: {
      type: Object,
      default: () => ({ is_redirect_to_wa: false, wa_phone_number: null, wa_message: null }),
    },
    assignedSalespersonOptions: { type: Array, default: () => [] },
    isManualInput: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
$primary: #1675bc;

.lp-v2-contact {
  padding: 5rem 0;
  background: #1a1a2e;
}

.lp-v2-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.lp-v2-contact-head {
  text-align: center;
  margin-bottom: 2.5rem;
}

.lp-v2-contact-label {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #7fbaee;
  margin-bottom: 0.75rem;
}

.lp-v2-contact-title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: #fff;
  line-height: 1.25;
  margin-bottom: 0.75rem;
}

.lp-v2-contact-desc {
  color: rgba(255, 255, 255, 0.65);
  font-size: 1rem;
  line-height: 1.75;
  max-width: 560px;
  margin: 0 auto;
}

.lp-v2-contact-form-wrap {
  background: #fff;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);

  @media (max-width: 575px) {
    padding: 1.5rem;
    border-radius: 12px;
  }
}

.lp-v2-ext-links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.lp-v2-ext-btn {
  display: inline-block;
  padding: 0.5rem 1.4rem;
  border: 2px solid;
  border-radius: 50rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
}
</style>
